import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, Modal, Button, useTheme } from "@mui/material";
import LibraryAddTwoToneIcon from "@mui/icons-material/LibraryAddTwoTone";
import BorderColorTwoToneIcon from "@mui/icons-material/BorderColorTwoTone";
import CancelPresentationTwoToneIcon from "@mui/icons-material/CancelPresentationTwoTone";

import PriceCheckTwoToneIcon from "@mui/icons-material/PriceCheckTwoTone";
// Success
import FileDownloadDoneTwoToneIcon from "@mui/icons-material/FileDownloadDoneTwoTone";
import RoleRateForm from "../view/employee/InfoEmployee/RolerateForm";
import EmployeeZonesForm from "../view/employee/InfoEmployee/EmployeeZonesForm";
import AddAllEmployees from "./tableContainer/AddAllEmployees";
import AddNumber from "../view/WhatsAppNumber/Numbers/AddNumber";
import UpdateNumber from "../view/WhatsAppNumber/Numbers/UpdateNumber";
import ChangePaidStatusForm from "../view/Reports/ReportPage/LiveActionsComponents/ChangePaidStatusForm";
import AddServiceToMember from "../view/Members/Info/AddServiceToMember";
import Void from "../view/Reports/ReportPage/LiveActionsComponents/Void";
import Comp from "../view/Reports/ReportPage/LiveActionsComponents/Comp";
import FormCharge from "../view/Members/Info/FormCharge";
import AddCurrency from "../view/Companies/Curency/AddCurrency";
import UpdateCurrency from "../view/Companies/Curency/UpdateCurrency";
import SettingsForm from "../view/Sites/SettingsForm";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 550,
  borderRadius: "8px",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 8,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  gap: "20px",
};

const getIcon = (name) => {
  switch (name) {
    case "add":
      return LibraryAddTwoToneIcon;
    case "edit":
      return BorderColorTwoToneIcon;
    case "delete":
      return CancelPresentationTwoToneIcon;
    case "pay":
      return PriceCheckTwoToneIcon;
    case "success":
      return FileDownloadDoneTwoToneIcon;
    default:
      return LibraryAddTwoToneIcon;
  }
};

const ModalBox = ({
  open = false,
  handleClose = () => {},
  handleOperation = () => {},
  operation = "",
  text = "",
  Send = false,
  btnLabel = "Done, Close it",
  navigateLink = null,
  navigateMessage = null,
  addRate = false,
  existSite = false,
  openService = false,
  member,
  employee,
  editRoleZoneEmp = false,
  row,
  roleId,
  setRoleId,
  inSiteDetails = false,
  whatsAppNumber,
  existRow,
  height,
  currency,
}) => {
  const handleFunction = () => {
    handleOperation();
    handleClose();
  };

  let theme = useTheme();
  const navigate = useNavigate();
  const CurrentIcon = getIcon(operation);
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={{ ...style, height: height ? height : 500 }}>
        {operation === "settings" ? (
          <SettingsForm handleClose={handleClose} siteInfo={existRow} />
        ) : openService ? (
          <AddServiceToMember
            member={member}
            handleClose={handleClose}
            existRow={existRow}
          />
        ) : (
          <>
            {editRoleZoneEmp ? (
              <>
                <EmployeeZonesForm
                  existSite={existSite}
                  roleId={roleId}
                  setRoleId={setRoleId}
                  row={row}
                  open={open}
                  handleEditRateClose={handleClose}
                  inSiteDetails={inSiteDetails}
                />
              </>
            ) : (
              <>
                {addRate ? (
                  <>
                    <RoleRateForm
                      existSite={existSite}
                      employee={employee}
                      open={open}
                      handleAddRateClose={handleClose}
                    />
                  </>
                ) : (
                  <>
                    {Send ? (
                      <AddAllEmployees handleClose={handleClose} site={row} />
                    ) : (
                      <>
                        {whatsAppNumber ? (
                          <>
                            {whatsAppNumber.type === "Add" ? (
                              <AddNumber
                                handleToggle={whatsAppNumber?.handleToggle}
                              />
                            ) : (
                              <UpdateNumber
                                handleToggle={whatsAppNumber?.handleToggle}
                                number={whatsAppNumber?.viewDate}
                              />
                            )}
                          </>
                        ) : (
                          <>
                            {operation === "UpdateCurrency" ? (
                              <UpdateCurrency
                                handleClose={handleClose}
                                currency={currency}
                              />
                            ) : operation === "AddCurrency" ? (
                              <AddCurrency handleClose={handleClose} />
                            ) : operation === "PaidStatus" ? (
                              <>
                                <ChangePaidStatusForm
                                  row={row}
                                  PaidFunction={handleOperation}
                                  handleClose={handleClose}
                                />
                              </>
                            ) : (
                              <>
                                {operation === "Void" ? (
                                  <Void
                                    row={row}
                                    PaidFunction={handleOperation}
                                    handleClose={handleClose}
                                  />
                                ) : (
                                  <>
                                    {operation === "Comp" ? (
                                      <Comp
                                        row={row}
                                        PaidFunction={handleOperation}
                                        handleClose={handleClose}
                                      />
                                    ) : (
                                      <>
                                        {operation === "chargeMember" ? (
                                          <FormCharge
                                            row={row}
                                            handleClose={handleClose}
                                          />
                                        ) : (
                                          <>
                                            <CurrentIcon
                                              sx={{ fontSize: "170px", mb: 5 }}
                                            />
                                            <Typography
                                              id="modal-modal-description"
                                              sx={{
                                                textAlign: "center",
                                                fontWeight: 600,
                                                mb: 2,
                                              }}
                                            >
                                              {text}{" "}
                                            </Typography>
                                            {navigateLink &&
                                              navigateLink?.map((link, i) => (
                                                <Typography
                                                  id="modal-modal-description"
                                                  sx={{
                                                    textAlign: "center",
                                                    fontWeight: 600,
                                                    // mb: 2,
                                                    color: "#95A4FC",
                                                    "&:hover": {
                                                      textDecoration:
                                                        "underline",
                                                      cursor: "pointer",
                                                    },
                                                  }}
                                                  onClick={() => navigate(link)}
                                                >
                                                  {navigateMessage[i]}
                                                </Typography>
                                              ))}
                                            <Box sx={{ width: "100%" }}>
                                              <Button
                                                onClick={handleFunction}
                                                sx={{
                                                  background:
                                                    theme.color.blackBackground,
                                                  color: "white",
                                                  width: "100%",
                                                  mb: 1.3,
                                                  "&:hover": {
                                                    background: `${theme.color.black}`,
                                                  },
                                                }}
                                              >
                                                {btnLabel}
                                              </Button>

                                              {operation === "delete" ||
                                                (operation === "pay" && (
                                                  <Button
                                                    onClick={handleClose}
                                                    sx={{
                                                      background:
                                                        theme.color.gray200,
                                                      color: "black",
                                                      width: "100%",
                                                      "&:hover": {
                                                        background: `${theme.color.gray300}`,
                                                      },
                                                    }}
                                                  >
                                                    Cancel
                                                  </Button>
                                                ))}
                                            </Box>
                                          </>
                                        )}
                                      </>
                                    )}
                                  </>
                                )}
                              </>
                            )}
                          </>
                        )}
                      </>
                    )}
                  </>
                )}
              </>
            )}
          </>
        )}
      </Box>
    </Modal>
  );
};

export default React.memo(ModalBox);
